import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const Kouzou = props => {
  return <Dropdown.Static kubunKey='kouzou' {...props} />
}
